import { render, staticRenderFns } from "./ToiletBoxListScreen.vue?vue&type=template&id=45d70dac&scoped=true&lang=pug"
import script from "./ToiletBoxListScreen.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxListScreen.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxListScreen.vue?vue&type=style&index=0&id=45d70dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d70dac",
  null
  
)

export default component.exports